'use strict';

const TeamTailorJobs = {
    init: function () {
        const filterBtns = document.querySelectorAll('.tt-jobs__filter-btn');
        const cards      = document.querySelectorAll('#tt-jobs-grid .tt-jobs__card');
        const countEl    = document.querySelector('.tt-jobs__count');

        if (!filterBtns.length) {
            return;
        }

        filterBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const filter = btn.getAttribute('data-filter');

                filterBtns.forEach(b => {
                    b.classList.remove('is-active');
                    b.setAttribute('aria-pressed', 'false');
                });
                btn.classList.add('is-active');
                btn.setAttribute('aria-pressed', 'true');

                let visible = 0;
                cards.forEach(card => {
                    if (filter === 'all' || card.getAttribute('data-department') === filter) {
                        card.removeAttribute('hidden');
                        visible++;
                    } else {
                        card.setAttribute('hidden', '');
                    }
                });

                if (countEl) {
                    countEl.textContent = visible + ' open position' + (visible !== 1 ? 's' : '');
                }
            });
        });
    }
};

export default TeamTailorJobs;
